// extracted by mini-css-extract-plugin
export default {"accordion":"Ri4XE","accordion-opened":"vZxVN","heading":"iPrFD","button":"GHz6x","title":"eoBq4","skeleton":"fTGZ0","icon":"YFjVL","content-wrapper":"oQsrZ","content":"pEExg"};